import React, { useState } from 'react';
import PrivatePage from '../base/private';
import {Container, makeStyles, Grid, Button} from '@material-ui/core';
import { COLORS } from '../../constants/colors';
import Section from '../../components/common/section';
import Input from '../../components/common/input';
import useNotification from '../../hooks/useNotification';
import { getCandidatesByDate } from '../../api/candidate';
import { CSVLink } from 'react-csv';
import { useEffect } from 'react';

const useStyles = makeStyles({
  root: {
    '& .grey--header': {
      backgroundColor: COLORS.grayScale[4],
    },
    '& .action-cell': {
      justifyContent: 'center'
    }
  },
  container: {
    maxWidth: '90rem',
    padding: '2rem 3.125rem',
  },
  loader: {
    paddingTop: '3rem',
  },
  reportContainer: {
    marginBottom: '2.0625rem'
  },
  reportTitle: {
    fontSize: '1.75rem',
    fontWeight: '500',
  },
  inputsContainer: {
    display: 'flex',
  },
  inputsLabel: {
    fontSize: '1rem',
    marginBottom: '0.5rem',
    display: 'block'
  },
  inputs: {
    width: '250px',
    marginRight: '1rem',
  },
  downloadContainer:{
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'end',
    marginBottom: '0.625rem'
  },
  hiddenCsv: {
    visibility: 'hidden'
  }
});

const emptyCandidateRow = {
  "firstName": "",
  "lastName": "",
  "city": "",
  "country": "",
  "createdAt": "",
  "overview": ""
}

const UsersPage = () => {
  const classes = useStyles();
  const [from, setFrom] = useState('')
  const [to, setTo] = useState('')
  const [candidatesData, setCandidatesData] = useState([])
  const [loading, setLoading] = useState(false)
  const notifications = useNotification();


  const getCandidates = async () => {
    setLoading(true)
    getCandidatesByDate({from, to}).ready()
    .then((res) => {
      if (res.success){
        if(res.data.length === 0){
          notifications.error({ message: 'No candidates were added in the given range of dates', });
        }
        setCandidatesData([
          ...res.data,
          emptyCandidateRow,
          {
            firstName: `Total candidates: ${res.data.length}`,
          }
        ]) 
      }else{
        notifications.error({ message: 'An error has occured while downloading candidates report.', });
      }
      setLoading(false)
    })
  }

  useEffect(() => {
    if(candidatesData.length > 0){
      document.getElementById('csv').click()
    }
  }, [candidatesData])
  
      
  return (
    <PrivatePage>
        <div className={classes.root}>
          <section>
            <Container className={classes.container}>
              <Section title="Reports">
                <section>
                  <h3 className={classes.reportTitle}>
                    Candidates by creation date
                  </h3>
                  <Grid container direction="row" className={classes.reportContainer}>
                    <Grid className={classes.inputsContainer} item>
                      <div>
                        <label className={classes.inputsLabel}>
                          Added from
                        </label>
                        <Input
                          className={classes.inputs}
                          value={from}
                          placeholder="From"
                          type='date'
                          onChange={({ target }) => setFrom(target.value)}
                        />
                      </div>
                      <div>
                        <label className={classes.inputsLabel}>
                          Added to
                        </label>
                        <Input
                          className={classes.inputs}
                          value={to}  
                          placeholder="To"
                          type='date'
                          onChange={({ target }) => setTo(target.value)}
                        />
                      </div>
                    </Grid>
                    <Grid item className={classes.downloadContainer} xs>
                      <Button onClick={getCandidates} variant="contained" color="primary" disabled={!from || !to || loading}>Download</Button>
                      <div className={classes.hiddenCsv}>
                        <CSVLink id='csv' filename={`candidates-${from}-to-${to}.csv`} data={candidatesData} target="_blank" />
                      </div>
                    </Grid>
                  </Grid>
                </section>

              </Section>
            </Container>
          </section>
        </div>
 

    </PrivatePage>
  );
};

export default UsersPage;